import { createStore } from "vuex";
import { modules } from "./modules";
import { plugins } from "./plugins";
import { Store } from "./state";

export const store = createStore({
  plugins,
  modules,
}) as Store;
